export const AddOn = (props: React.SVGProps<SVGSVGElement>) => (
	<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5.04993 5.05017V8.95012H8.94988V5.05017H5.04993ZM2.94995 5.00017C2.94995 3.868 3.86776 2.9502 4.99993 2.9502H8.99988C10.1321 2.9502 11.0499 3.868 11.0499 5.00017V9.00012C11.0499 10.1323 10.1321 11.0501 8.99988 11.0501H4.99993C3.86776 11.0501 2.94995 10.1323 2.94995 9.00012V5.00017Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5.04993 15.0483V18.9483H8.94988V15.0483H5.04993ZM2.94995 14.9984C2.94995 13.8662 3.86776 12.9484 4.99993 12.9484H8.99988C10.1321 12.9484 11.0499 13.8662 11.0499 14.9984V18.9983C11.0499 20.1305 10.1321 21.0483 8.99988 21.0483H4.99993C3.86776 21.0483 2.94995 20.1305 2.94995 18.9983V14.9984Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M15.05 15.0483V18.9483H18.95V15.0483H15.05ZM12.95 14.9984C12.95 13.8662 13.8679 12.9484 15 12.9484H19C20.1321 12.9484 21.05 13.8662 21.05 14.9984V18.9983C21.05 20.1305 20.1321 21.0483 19 21.0483H15C13.8679 21.0483 12.95 20.1305 12.95 18.9983V14.9984Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12.95 7.00015C12.95 6.42026 13.4201 5.95016 14 5.95016H20C20.5799 5.95016 21.05 6.42026 21.05 7.00015C21.05 7.58004 20.5799 8.05014 20 8.05014H14C13.4201 8.05014 12.95 7.58004 12.95 7.00015Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M17 2.9502C17.5799 2.9502 18.05 3.42029 18.05 4.00018V10.0001C18.05 10.58 17.5799 11.0501 17 11.0501C16.4201 11.0501 15.95 10.58 15.95 10.0001V4.00018C15.95 3.42029 16.4201 2.9502 17 2.9502Z"
			fill="currentColor"
		/>
	</svg>
);
